<!-- 查看充值单详情 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container view-recharge">
      <el-form v-loading="formLoading" :model="viewObj" label-width="110px">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <!-- 用户编码 -->
        <el-form-item :label="$t('fiPayAdvice.userCode')+ ':'">{{ viewObj.userCode }}</el-form-item>
        <!-- 当日序号 -->
        <el-form-item :label="$t('fiBankbookTemp.serial')+ ':'">{{ viewObj.serial }}</el-form-item>
        <!-- 单据类型 -->
        <el-form-item :label="$t('fiAcInput.orderType')+ ':'">{{ $t('efubo.card.record.type2') }}</el-form-item>
        <!-- 账户类型 -->
        <el-form-item :label="$t('title.accout.type')+ ':'">{{ $lt(initDict.type, viewObj.acType) }}</el-form-item>
        <!-- 充值方式 -->
        <el-form-item :label="$t('fiBankbookTempRecharge.moneyType')+ ':'">{{ $lt(initDict.moneyType, viewObj.tranType) }}</el-form-item>
        <!--  本地货币金额-->
        <el-form-item :label="$t('fiBankbookTemp.localMoney')+ ':'">{{ viewObj.money }}</el-form-item>
        <!-- 本地货币代码 -->
<!--        <el-form-item :label="$t('fiBankbookTemp.localCurrency')+ ':'">{{ viewObj.localCurrency }}</el-form-item>-->
        <!-- 金额 -->
        <el-form-item :label="$t('pmEfuboCard.amount')+ ':'">{{ viewObj.localMoney }}</el-form-item>
        <!-- 摘要 -->
        <el-form-item :label="$t('sys.notes')+ ':'">{{ viewObj.remark }}</el-form-item>
        <!-- 状态 -->
        <el-form-item :label="$t('fiBankbookTemp.status')+ ':'">{{ $lt(initDict.status, viewObj.status) }}</el-form-item>
        <!-- 创建时间 -->
        <el-form-item :label="$t('Common.createTime')+ ':'">{{ viewObj.createTime }}</el-form-item>
        <!-- 审核时间 -->
        <el-form-item :label="$t('pmProductSppm.checkDate')+ ':'">{{ viewObj.checkeTime }}</el-form-item>
        <!-- 入帐时间 -->
        <el-form-item :label="$t('fi.credit.time')+ ':'">{{ viewObj.recheckeTime }}</el-form-item>
        <div style="text-align: center; margin-bottom: 10px">
          <el-button icon="el-icon-close" @click="$router.back(-1)">{{ $t('operation.button.cancel') }}</el-button>
        </div>
        <div v-if="viewObj.imgs">
          <h3 style="color: #b3640d">{{ $t('mimember.uploadfile.files') }}</h3>
          <div v-for="v in viewObj.imgs" :key="v.id">
            <img style="width: 300px;height: 200px" :src="v.fileUrl" alt="">
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { viewFiAcInput } from '@/api/ay-account-manager'
export default {
  name: "ViewRecharge",
  data() {
    return {
      viewObj: {
        userCode: '',
        serial: '',
        acType: '',
        tranType: '',
        money: '',
        localCurrency: '',
        localMoney: '',
        counterCode: '',
        remark: '',
        status: '',
        createTime: '',
        checkeTime: '',
        recheckeTime: '',
        imgs: []
      },
      srcList: [],
      formLoading: false,
      initDict: {
        type: 'fiacinput.actype.cn',
        moneyType:'trans_type_cn',
        counterCode:'acinput_countercode',
        status:'fi_ac_input_status_cn'
      }
    }
  },
  created() {
    this.viewId = this.$route.params.id
    this.formLoading = true
    viewFiAcInput({ 'id': this.$route.params.id }).then(res => {
      this.viewObj = {
        userCode: res.data.userCode,
        serial: res.data.serial,
        acType: res.data.acType,
        tranType: res.data.tranType,
        money: res.data.money,
        localCurrency: res.data.localCurrency,
        localMoney: res.data.localMoney,
        counterCode: res.data.counterCode,
        remark: res.data.remark,
        status: res.data.status,
        createTime: res.data.createTime,
        checkeTime: res.data.checkeTime,
        recheckeTime: res.data.recheckeTime,
        imgs: res.data.imgs
      }
      this.formLoading = false
    }).catch(() => {
      this.$message.error(this.$t('bdSendRegister.operaterFail'))
      this.$router.go(-1)
    })
  }
}
</script>

<style scoped lang="scss">
.view-recharge {
  ::v-deep .el-form-item {
    margin: 0;
  }
}
</style>
